import { render, staticRenderFns } from "./ParsedItemDisplay.vue?vue&type=template&id=ffb66a74&scoped=true&"
import script from "./ParsedItemDisplay.vue?vue&type=script&lang=js&"
export * from "./ParsedItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ParsedItemDisplay.vue?vue&type=style&index=0&id=ffb66a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb66a74",
  null
  
)

export default component.exports